import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import type { PropsWithChildren, ReactNode } from 'react';
import { Children } from 'react';
import styled from 'styled-components';

import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Collapse as CollapseAtom } from '@sorare/core/src/atoms/layout/Collapse';
import {
  Horizontal,
  SBHorizontal,
  Vertical,
} from '@sorare/core/src/atoms/layout/flex';
import { BodyS, BrandXXS } from '@sorare/core/src/atoms/typography';
import { useToggle } from '@sorare/core/src/hooks/useToggle';

const Collapse = styled(CollapseAtom)`
  overflow: hidden;
  padding: 0 var(--double-unit);
`;
const LeftAlignedVertical = styled(Vertical)`
  align-items: flex-start;
`;
const SBHorizontalWithPadding = styled(SBHorizontal)`
  padding: 0 var(--double-unit);
`;

type Props = {
  title: ReactNode;
  subtitle?: ReactNode;
  expandedByDefault?: boolean;
};
export const Section = ({
  children,
  title,
  subtitle,
  expandedByDefault = true,
}: PropsWithChildren<Props>) => {
  const [expanded, toggleExpanded] = useToggle(expandedByDefault);

  return (
    <Vertical>
      {!!title && (
        <ButtonBase onClick={toggleExpanded}>
          <SBHorizontalWithPadding>
            <LeftAlignedVertical gap={0.5}>
              <Horizontal gap={0.5}>
                {title}
                {!expanded && (
                  <BrandXXS>({Children.toArray(children).length})</BrandXXS>
                )}
              </Horizontal>
              <BodyS color="var(--c-nd-500)">{subtitle}</BodyS>
            </LeftAlignedVertical>
            <FontAwesomeIcon icon={expanded ? faChevronUp : faChevronDown} />
          </SBHorizontalWithPadding>
        </ButtonBase>
      )}
      <Collapse open={expanded} gap={0.5}>
        <Vertical gap={1.5}>{children}</Vertical>
      </Collapse>
    </Vertical>
  );
};
